const STORAGE_KEY = 'somalive:addedProducts';
const DELETED_KEY = 'somalive:deletedProducts';

interface AddedProductEntry {
  id: number;
  id_button: number;
  [key: string]: unknown;
}

const read = (): AddedProductEntry[] => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? (JSON.parse(stored) as AddedProductEntry[]) : [];
  } catch {
    return [];
  }
};

const write = (value: AddedProductEntry[]): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // sessionStorage indisponível
  }
};

export const addPendingProduct = (product: AddedProductEntry): void => {
  // Cross-cleanup: se estava marcado como deletado, cancelar
  try {
    const deleted = sessionStorage.getItem(DELETED_KEY);
    if (deleted) {
      const parsed = JSON.parse(deleted) as Array<{ productId?: string; id_button?: number }>;
      sessionStorage.setItem(
        DELETED_KEY,
        JSON.stringify(
          parsed.filter(
            (p) => !(p.productId === String(product.id) && p.id_button === product.id_button)
          )
        )
      );
    }
  } catch {
    // sessionStorage indisponível
  }

  const existing = read();
  const alreadyExists = existing.some(
    (p) => p.id === product.id && p.id_button === product.id_button
  );
  if (!alreadyExists) {
    write([...existing, product]);
  }
};

export const removePendingProduct = (productId: number, id_button: number): void => {
  write(read().filter((p) => !(p.id === productId && p.id_button === id_button)));
};

// Chamado após carregar produtos da API: limpa entradas cujo produto já está no cache
export const cleanupConfirmedAdditions = (
  apiProducts: Array<{ id?: number | string }>,
  id_button: number
): void => {
  const pending = read().filter((p) => p.id_button === id_button);
  const confirmed = pending.filter((p) =>
    apiProducts.some((ap) => String(ap.id ?? '') === String(p.id))
  );
  confirmed.forEach((p) => removePendingProduct(p.id, id_button));
};
